<div class="app-header">
    <header id="header" class="app-header">
        <div class="app-logo">
            <img id="logo" src="assets/images/favicon.png"/>
            <div class="title">
                SIA
            </div>
        </div>
        <nav mat-tab-nav-bar #navBar>
            <a mat-tab-link *ngFor="let link of navLinks" [routerLink]="link.link" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive">
                {{link.label}}
            </a>
            <a mat-tab-link [href]="newRelic.link" [target]="newRelic.target">
                {{newRelic.label}}
            </a>
        </nav>
        <div class="header-toolbar">
            <div class="tools">
                <mat-icon routerLink="settings" matTooltip="Admin Page" *ngIf="isAdminUser()">settings</mat-icon>
                <mat-icon routerLink="profile" matTooltip="User Settings">person</mat-icon>
                <mat-icon (click)="logout()" matTooltip="Logout">exit_to_app</mat-icon>
            </div>
            <div class="user-info">
                <p class="active-user">{{ userLogged() }}</p>
                <img src="assets/images/user.jpg" />
            </div>
        </div>
    </header>
</div>